import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {EmptyState, Icon, SectionHeading} from "peggirkit";
import {CheckCircleIcon} from "@heroicons/react/24/outline";
import {DayReport} from "@/data/entities/dayReport";
import RefundsTable from "@widgets/reports/dayReport/refunds/RefundsTable";

type Props = {
    dayReport: DayReport,
};

/**
 * Online payments of the day to refund via Mollie (fully when cancelled,
 * partly when the total went down).
 */
const DayReportRefunds = ({dayReport}: Props) => {
    const intl = useIntl();
    return (
        <div className={"mt-6 md:mt-12 flex flex-col gap-4"}>
            <SectionHeading
                title={<FormattedMessage id={"dayReport.refunds"}/>}
                description={intl.formatMessage({id: "dayReport.refunds.description"})}
            />

            {
                dayReport.refunds.length === 0
                    ? (
                        <EmptyState
                            containerClassname={"py-6"}
                            icon={<Icon icon={CheckCircleIcon}/>}
                            title={<FormattedMessage id={"dayReport.noRefunds"}/>}
                            description={<FormattedMessage id={"dayReport.noRefunds.description"}/>}
                        />
                    )
                    : <RefundsTable refunds={dayReport.refunds}/>
            }
        </div>
    );
};

export default DayReportRefunds;